import { render, staticRenderFns } from "./Quality_Management.vue?vue&type=template&id=f6f112d0&scoped=true"
import script from "./Quality_Management.vue?vue&type=script&setup=true&lang=js"
export * from "./Quality_Management.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Quality_Management.vue?vue&type=style&index=0&id=f6f112d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f112d0",
  null
  
)

export default component.exports